$( document ).on('turbolinks:load', function() {
  $(".btn-checkbox").each(function() {
   $(this).parent().css("display", "block");
   $(this).after($("<div>").addClass("btn-group w-full")
   .prepend(
     $("<label>").addClass("btn btn-primary").attr('for', $(this).context.id)
     .append([$("<span>").addClass("glyphicon glyphicon-ok").attr('for', $(this).context.id), $("<span>").addClass("fa fa-square-o size-lg")]))
   .append($("<label>").addClass("btn btn-default btn-checkbox-label active ").attr('for', $(this).context.id).text($(this).attr("label"))));
  });
});
